export const hoursToMilliseconds = (hours: number) => hours * 60 * 60 * 1_000;
export const minutesToHours = (minutes: number) => minutes / 60.0;
export const hoursToMinutes = (hours: number) => hours * 60.0;

export const DEFAULT_DEBOUNCE_TIME = 1500;

export const TIME_REGEX = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

export const isValidTimeStr = (timeStr: string) => TIME_REGEX.test(timeStr);

export const minutesToHoursAndMinutes = (totalMinutes: number) => {
  if (!totalMinutes) return [0, 0];
  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.floor(totalMinutes % 60);
  return [hours, minutes];
};

export const calculateTimeDifferenceInHours = (
  startTime: string,
  endTime: string,
): number => {
  if (
    !startTime ||
    !endTime ||
    !isValidTimeStr(startTime) ||
    !isValidTimeStr(endTime)
  ) {
    return 0;
  }

  const [startHour, startMin] = startTime.split(':').map(Number);
  const [endHour, endMin] = endTime.split(':').map(Number);

  const startTotalMin = startHour * 60 + startMin;
  const endTotalMin = endHour * 60 + endMin;

  const diffMin = endTotalMin - startTotalMin;
  if (diffMin <= 0) return 0;

  return minutesToHours(diffMin);
};

/**
 * Normalizes arbitrary time-like strings to HH:mm.
 * - Accepts inputs like: "09:00", "9:00", "09:00:00.000Z", "17:00:00+01:00"
 * - Returns empty string if a valid HH:mm cannot be extracted
 */
export const normalizeTimeToHHmm = (value?: string | null): string => {
  if (!value) return '';
  // Prefer strict HH:mm at the start
  const strict = /^([0-1][0-9]|2[0-3]):([0-5][0-9])/.exec(value);
  if (strict) return `${strict[1]}:${strict[2]}`;

  // Fallback for H:mm (single-digit hours)
  const singleHour = /^([0-9]):([0-5][0-9])/.exec(value);
  if (singleHour) {
    const hh = `0${singleHour[1]}`;
    const mm = singleHour[2];
    return `${hh}:${mm}`;
  }

  return '';
};
